import { ErrorBoundary } from 'components'
import { Outlet } from 'react-router-dom'

const Minimal = () => {
  return (
    <ErrorBoundary>
      <Outlet />
    </ErrorBoundary>
  )
}

export default Minimal
